import { ApiHttpService } from '../ApiHttpService';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const GLOSSARY_PATH = 'articulos/Glosario';

class GlossaryController {
  static async find(id) {
    const params = ParamsHelper.createQueryParams({
      gloId: id,
    });
    const response = await ApiHttpService.get(`${GLOSSARY_PATH}${params}`);
    return response.data;
  }
}

export { GlossaryController };



// WEBPACK FOOTER //
// ./src/networking/controllers/GlossaryController.js